import { UserEntityProfile, UserEntityProfileBase } from "./user-entity-profile.model"


export class UserEntityBase {

    id: number = 0
    entityId: number = 0
    userId: number = 0
    defaultEntity: boolean = false
    active: boolean = false
    profiles: UserEntityProfile[] = []

    hasProfile(type: number): boolean {
        return this.profiles.filter(p => p.type == type).length > 0
    }

    static fromUserEntity(userEntity: UserEntity): UserEntityBase{
        let current = new UserEntityBase()
        if (userEntity == null) {
            return current
        }

        Object.assign(current, userEntity)
        
        current.profiles = []
        userEntity.profiles.forEach(p => {            
            let up = UserEntityProfileBase.fromUserEntityProfile(p)            
            current.profiles.push(up)
        })

        return current
    }
}

export interface UserEntity extends UserEntityBase {
    
}